/**
 * Labstep
 *
 * @module components/Filter/Menu/List
 * @desc Filters menu list
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { usePremiumFeatureStatus } from 'labstep-web/hooks/premium-feature';
import React from 'react';
import type { FilterMenuListProps } from './types';

export const FilterMenuList: React.FC<FilterMenuListProps> = ({
  filtersContent,
  filters,
}) => {
  const premiumFilterOptions = usePremiumFeatureStatus(
    filtersContent,
    'name',
    'filters',
  );

  return (
    <>
      {premiumFilterOptions.map(
        ({
          name,
          component,
          actionComponentProps,
          premiumFeature,
          premiumFeatureEnabled,
        }) => {
          if (filters.includes(name) && component) {
            if (!premiumFeature || premiumFeatureEnabled) {
              return (
                <React.Fragment key={name}>
                  {component}
                </React.Fragment>
              );
            }
            if (!premiumFeatureEnabled) {
              return (
                <React.Fragment key={name}>
                  <ActionComponent
                    type="option"
                    premiumFeature={premiumFeature}
                    {...actionComponentProps}
                  />
                </React.Fragment>
              );
            }
          }
          return null;
        },
      )}
    </>
  );
};
